/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";

export const ButtonGroup = styled(FlexContainer)`
  > *,
  button {
    border-right: ${theme.borders.disabled};
    border-left: ${theme.borders.disabled};

    /* 2 selectors of different specificity are bundled together for readability */
    /* stylelint-disable no-descending-specificity */
    &:first-child,
    button &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-left: none;
    }

    &:last-child,
    button &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-right: none;
    }
    /* stylelint-enable no-descending-specificity */

    &:not(:first-child):not(:last-child),
    button &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }
  }
`;
